module.exports = __webpack_public_path__ + "static/media/italics.a8097ed6.svg";